import { render, staticRenderFns } from "./BookingModuleMain.vue?vue&type=template&id=09582a02"
import script from "./BookingModuleMain.vue?vue&type=script&lang=js"
export * from "./BookingModuleMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports